import { ReceiptPercentIcon } from "@heroicons/react/24/solid";
import invoicesLogo from "../../src/assets/images/invoices.png";
const VIPLargeCard = ({ title, className, count, src }) => {
  return (
    <>
      <div className={`${className}`}>
        <div className="flex flex-col w-full justify-between p-2 gap-x-2">
          <div className="w-full">
            <div
              //   onClick={() => {
              //     onClickView();
              //   }}
              className="text-gray-600 p-2 font-medium flex flex-row justify-between"
            >
              <ReceiptPercentIcon className="text-white h-6 w-6" />
              <h1 className="ml-2 mr-auto truncate text-sm font-normal text-white">{title}</h1>
            </div>
          </div>
          <div className="flex flex-row w-full justify-between p-2 gap-x-2">
            <h1 className="mr-auto ml-20 truncate text-center font-bold text-white text-4xl uppercase mt-1">
              {count}
            </h1>
            <div>
              <img src={src} className="w-full object-cover" />
            </div>
          </div>
          {/* <div className="w-1/2 ml-2">
            <div className="w-1/2 border-b-2 border-grey-200 my-3"></div>
            <div className="w-full border-b-2 border-grey-200 my-3"></div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default VIPLargeCard;
